import { useStore } from 'react-redux';

export default Component => (props) => {
	return <Component store={useStore()} {...props} />
};